import * as React from 'react';
import Tabs, { tabsClasses } from '@mui/material/Tabs';
import LinkTab from '@mui/material/Tab';
import { Paper, Tab } from '@mui/material';
import '../../App.css'
import { Link } from 'react-router-dom';

const CategoryChooser = ({changedTab, value}) => {
    return(
        <div className='reducedCard' style={{marginBottom:'20px', marginTop:'-43px'}}>
        <Paper elevation={1} style={{ textAlign: 'center'}}>
            <Tabs
            variant="scrollable"
            onChange={changedTab}
            style={{borderRadius:'2px'}}
            value={value}
            scrollButtons={true}
            allowScrollButtonsMobile
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="visible arrows tabs example"
            // sx={{
            // [`& .${tabsClasses.scrollButtons}`]: {
            //     '&.Mui-disabled': { opacity: 0.3 },
            // },
            // }.Mui}
        >
            <Tab label="Актуелно" />
            <Tab label="Локално"/>
            <Tab label="Економија"/>
            <Tab label="Свет"/>
            <Tab label="Наука и Технологија" />
            <Tab label="Спорт"/>
            <Tab label="Култура" />
        </Tabs>
      </Paper>
      </div>
    )
}

export default CategoryChooser;